// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3yGEd","errors":"Errors_errors__jWDWK"};